/**
 * @param {object} offer
 * @returns {string}
 */
function readOfferMessageText(offer) {
  return typeof offer?._raw?.metadata?.message === "string" ? offer._raw.metadata.message.trim() : "";
}

/**
 * Whether a row belongs on the Messages tab (not Offers).
 * MESSAGE status always messages; OPEN rows with only a message body (no amount) too.
 *
 * @param {object} offer
 * @returns {boolean}
 */
export function isMessageOfferRow(offer) {
  const status = String(offer?._raw?.status ?? "").toUpperCase();
  if (status === "MESSAGE") return true;
  if (!readOfferMessageText(offer)) return false;
  return !(Number(offer?._offerAmount) > 0);
}

/**
 * Whether a transformed property-offer row should appear in offer lists.
 * Initial share threads are OPEN with no submitted offer — hide those.
 *
 * @param {object} offer
 * @returns {boolean}
 */
export function isVisibleOfferRow(offer) {
  const status = String(offer?._raw?.status ?? "").toUpperCase();
  if (status === "MESSAGE") return true;
  if (readOfferMessageText(offer)) return true;
  if (status !== "OPEN") return true;
  const explicitAmount = Number(offer?._raw?.calculation?.offer_amount);
  if (Number.isFinite(explicitAmount) && explicitAmount > 0) return true;
  const tipStatus = String(offer?._raw?.metadata?.tip_status ?? "")
    .trim()
    .toUpperCase();
  // Incoming collection shares can be OPEN with no amount until the investor counters.
  if (tipStatus === "AWAITING_YOUR_REPLY") return true;
  return false;
}

/**
 * Whether a row belongs in Offers & Messages. DRAFT rows only hydrate the DealLens calculator.
 *
 * @param {object} offer
 * @returns {boolean}
 */
export function isConversationRow(offer) {
  return String(offer?._raw?.status ?? "").toUpperCase() !== "DRAFT" && isVisibleOfferRow(offer);
}
